// 数据统计api
import axios from './Interceptor.js';
let address = window.global_config.BASE_URL2;
let tree = {
  //  list 数据
  GetPageList: info => {
    return axios({
      method: 'post',
      url: `${address}DataSetStandard/GetPageList`,
      data: info
    });
  },
  //  新增
  Add: info => {
    return axios({
      method: 'post',
      url: `${address}DataSetStandard/Add`,
      data: info
    });
  },
  //  修改
  Update: info => {
    return axios({
      method: 'post',
      url: `${address}DataSetStandard/Edit`,
      data: info
    });
  },
  //  删除
  Delete: info => {
    return axios({
      method: 'post',
      url: `${address}DataSetStandard/Delete`,
      data: info
    });
  },
  // 获取某个数据集id
  GetListId: info => {
    return axios({
      method: 'post',
      url: `${address}DataSetStandard/GetChildrenListById`,
      data: info
    });
  },
  QueryDateSetFillList: info => {
    return axios({
      method: 'post',
      url: `${address}DataSetStandard/QueryDateSetFillList`,
      data: info
    });
  }
};

export default tree;
